import React from "react";
import {GraphQlSelect} from "./GraphQlSelect";
import {useTvAreaQueryQuery} from "../../generated/graphql";

export const TVAreaSelect = (props) => {
    const query = useTvAreaQueryQuery();
    return <GraphQlSelect queryResult={query} {...props}  labelField="name" />;
}
